module.exports = __webpack_public_path__ + "res/28-img_game_bg_q_m.8e48c599fd0c92417d60b8d14032767b.png";